import { Button } from '@monorepo/shared/componentsV2/Button';
import TrashIcon from '@svg/trash.svg';
import { FormTemplateFieldConditionalRule } from 'mapistry-shared';
import React from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import styled from 'styled-components';

const StyledDeleteButton = styled(Button)`
  display: block;
  margin-top: 0.75rem;
`;

interface DeleteConditionalRuleButtonProps {
  deleteConditionalRule: () => void;
}

export function DeleteConditionalRuleButton({
  deleteConditionalRule,
}: DeleteConditionalRuleButtonProps) {
  const {
    fields: { value: conditionalRules },
  } = useFieldArray<FormTemplateFieldConditionalRule>('conditionalRules');

  const hasOnlyOneRule = conditionalRules.length === 1;

  if (hasOnlyOneRule) {
    return null;
  }

  return (
    <StyledDeleteButton color="secondary" onClick={deleteConditionalRule}>
      <TrashIcon aria-hidden />
      Delete rule
    </StyledDeleteButton>
  );
}
